<script>
  import { onMount } from 'svelte';
  import { listaProdutos } from '../../actions/database.js';
  import { produtos } from '../../store/store.js';

  import Page from "../../containers/Page/Page.svelte";
  import Table from "../../components/Produto/Table.svelte";

  $: list = $produtos;

  onMount(() => {
    listaProdutos();
  });
</script>

<Page title="Produtos Mente Aberta">
  <div class="section" style="padding-top: 0px;">
    <a class="button is-primary" href="/#/painel/produtos/criar">
      <strong>Adicionar produto</strong>
    </a>
    <br>
  </div>
  <div class="box">
    <Table { list }/>
  </div>
</Page>